import { render, staticRenderFns } from "./noticeViewPage.vue?vue&type=template&id=31835782&scoped=true&"
import script from "./noticeViewPage.vue?vue&type=script&lang=js&"
export * from "./noticeViewPage.vue?vue&type=script&lang=js&"
import style0 from "./noticeViewPage.vue?vue&type=style&index=0&id=31835782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31835782",
  null
  
)

export default component.exports